import React from "react";
import FAQsImg from "../../../img/FAQsImg.png"

export default function FaqIntro() {
    return (
        <div>
            <div className="grid md:grid-cols-2 grid-cols-1 px-20 my-16 md:text-left text-center">
                <div className="py-24">
                    <h1 className="text-5xl font-semibold">
                        Frequently <span className="text-blue-500">Asked</span> <span className="text-orange-400">Questions</span>
                    </h1>
                    <h3 className="text-xl font-semibold py-7">
                        Have a query? We're here to assist.
                    </h3>
                </div>
                <div>
                    <img src={FAQsImg} alt='' />
                </div>
            </div>
        </div>
    )
}   